/**
 * Constantes partagées pour l'application Deals
 * Synchronisé avec les enums backend Laravel
 */

export const typePersonne = [
    { value: 'PP', label: 'Personne physique' },
    { value: 'PM', label: 'Personne morale' },
] as const;

export const civilites = [
    { value: '0', label: 'Monsieur' },
    { value: '1', label: 'Madame' },
    { value: '3', label: 'Société' },
] as const;

export const quoteStatuts = [
    { value: 'in_progress', label: 'En cours' },
    { value: 'cancelled', label: 'Sans suite' },
    { value: 'won', label: 'Transformé' },
] as const;

export const quoteEtats = [
    { value: '1', label: 'Devis' },
    { value: '2', label: 'Contrat attente paiement' },
    { value: '3', label: 'Contrat payé' },
] as const;

export const produits = [
    { value: 'MotoAMO', label: 'Moto / Scooter' },
    { value: 'ScooterAMO', label: 'Cyclo' },
    { value: 'QuadAMO', label: 'Quad / Moto Verte' },
    { value: 'TrottinetteAMO', label: 'Trottinette' },
    { value: 'VeloAMO', label: 'Vélo' },
    { value: 'DeliveryAMO', label: 'Livraison' },
    { value: 'MaeNveiAMO', label: 'Trottinette MAE' },
] as const;

export const canaux = [
    { value: 'DW', label: 'Direct Web' },
    { value: 'DT', label: 'Direct Téléphone' },
    { value: 'DC', label: 'Direct Comparateur' },
    { value: 'CW', label: 'Courtier Web' },
    { value: 'CT', label: 'Courtier Téléphone' },
    { value: 'CC', label: 'Courtier Comparateur' },
    { value: 'CM', label: 'Courtier Concessionnaire' },
    { value: 'DM', label: 'Direct Concessionnaire' },
    { value: 'CB', label: 'Courtier marque blanche' },
] as const;

export const actesGestion = [
    { value: 'AN', label: 'Affaire nouvelle' },
    { value: 'AV', label: 'Avenant' },
] as const;

export const usageVehicules = [
    { value: 1, label: 'Promenade' },
    { value: 2, label: 'Promenade / Trajet travail' },
    { value: 3, label: 'Affaires' },
    { value: 4, label: 'Déplacements privés' },
    { value: 5, label: 'Privés et professionnels' },
    { value: 6, label: 'Tous déplacements' },
    { value: 7, label: 'Solo' },
    { value: 8, label: 'Famille' },
] as const;

export const formules = [
    { value: 'F1', label: 'Essentielle' },
    { value: 'F2', label: 'Equilibre' },
    { value: 'F3', label: 'Tous Risques' },
    { value: 'F4', label: 'Tous Risques' },
] as const;

export const fractionnements = [
    { value: 'A', label: 'Annuel' },
    { value: 'M', label: 'Mensuel' },
    { value: 'S', label: 'Semestriel' },
] as const;

export const typesMer = [
    { value: 'Souscrire', label: 'Souscrire' },
    { value: 'DemandeDevis', label: 'Demande de devis' },
    { value: 'Rappel', label: 'Rappel' },
    { value: 'ContacterConseiller', label: 'Contacter un conseiller' },
    { value: 'DevisOrange', label: 'Devis orange' },
    { value: 'AppGPT', label: 'Parcours GPT' },
    { value: 'AgentConv', label: 'Agent conversationnel' },
    { value: 'Fiche', label: 'Fiche MeilleurTaux' },
    { value: 'Autosave', label: 'Autosave LeLynx' },
] as const;

// Sources de leads B2C (clients hors gestionnaire commercial) — filtre liste devis (AMODEV-31915)
export const typesMerFilter = [
    { value: 'AppGPT', label: 'ChatGPT' },
    { value: 'AgentConv', label: 'Agent conversationnel' },
    { value: 'Fiche', label: 'Fiche MeilleurTaux' },
    { value: 'Autosave', label: 'Autosave LeLynx' },
] as const;

export const modesPaiementComptant = [
    { value: 'B', label: 'Carte bancaire' },
    { value: 'C', label: 'Chèque' },
    { value: 'P', label: 'PayPal' },
    { value: 'V', label: 'Virement' },
    { value: 'M', label: 'Mail' },
] as const;

export const modesPaiementTerme = [
    { value: 'B', label: 'Carte bancaire' },
    { value: 'C', label: 'Chèque' },
    { value: 'P', label: 'Prélèvement' },
    { value: 'V', label: 'Virement' },
] as const;

export const options = [
    { value: 'KSM', label: 'Casse Mécanique' },
    { value: 'ASSP', label: 'Assistance Panne 0km' },
    { value: 'ASSVR', label: 'Assistance Panne 0km + Véhicule remplacement' },
    { value: 'ACCEQ', label: 'Accessoires et équipements' },
    { value: 'RFRADTA', label: 'Rachat de franchise DTA' },
    { value: 'RAFRADTA', label: 'Rachat de franchise DTA' },
    { value: 'RFRAVI', label: 'Rachat de franchise Vol / Incendie' },
    { value: 'RAFRAVI', label: 'Rachat de franchise Vol / Incendie' },
    { value: 'VALMAJ', label: 'Valeur majorée' },
    { value: 'PCC1', label: 'Protection corporelle du conducteur' },
    { value: 'PCC2', label: 'Protection corporelle du conducteur' },
    { value: 'PCC3', label: 'Protection corporelle du conducteur' },
    { value: 'ASST', label: 'Assistance Mondial' },
    { value: 'MOB', label: 'Mobilité' },
    { value: 'ASS1', label: 'Assistance Accident' },
    { value: 'ASS2', label: 'Assistance Panne 0km' },
    { value: 'ASS3', label: 'Assistance Panne 0km + Véhicule remplacement' },
    { value: 'ASS1TSCA', label: 'Assistance Accident' },
    { value: 'ASS2TSCA', label: 'Assistance Panne 0km' },
    { value: 'ASS3TSCA', label: 'Assistance Panne 0km + Véhicule remplacement' },
    { value: 'ACCESSEQP', label: 'Accessoires et équipements' },
    { value: 'ACCESSEQP4', label: 'Accessoires et équipements' },
    { value: 'MBPACB1', label: 'Dommages corporels Plus' },
] as const;

// Types dérivés pour type-safety
export type QuoteStatut = typeof quoteStatuts[number]['value'];
export type QuoteEtat = typeof quoteEtats[number]['value'];
export type CodeProduit = typeof produits[number]['value'];
export type Canal = typeof canaux[number]['value'];
export type ActeGestion = typeof actesGestion[number]['value'];
export type UsageVehicule = typeof usageVehicules[number]['value'];
export type FormuleChoisie = typeof formules[number]['value'];
export type Fractionnement = typeof fractionnements[number]['value'];
export type TypeMer = typeof typesMer[number]['value'];
export type ModePaiementComptant = typeof modesPaiementComptant[number]['value'];
export type ModePaiementTerme = typeof modesPaiementTerme[number]['value'];
export type CodeOption = typeof options[number]['value'];
